module.exports = __webpack_public_path__ + "img/gb6181.prt.61169372.jpg";